import { ActionIcon, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const LockIcon = () => {
    const { t } = useTranslation();
    const isMainCameraLocked = usePlacementStore(useShallow((state) => state.isMainCameraLocked));
    const setIsMainCameraLocked = usePlacementStore((state) => state.setIsMainCameraLocked);

    const handleToggleLockView = () => {
        setIsMainCameraLocked(!isMainCameraLocked);
    };

    return (
        <Tooltip
            label={isMainCameraLocked ? t('buttonUnlockView') : t('buttonLockView')}
            position="bottom"
            variant={variants.tooltip.bottom}
        >
            <ActionIcon
                aria-label={isMainCameraLocked ? t('labelCameraLocked') : t('labelCameraUnlocked')}
                className="bg-background-transparent hover:bg-background-gray! pointer-events-auto action-icon-medium"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        handleToggleLockView();
                    }
                }}
                onPointerDown={handleToggleLockView}
            >
                {isMainCameraLocked ? 'lock' : 'lock_open'}
            </ActionIcon>
        </Tooltip>
    );
};
